import { useEffect } from 'react';
import useWebSocketStore from './zustand-stores/use-websocket-store';
import { SocialSearchProgress } from '@/lib/types/social-search';

export function useSocialSearchProgress(userId: string) {
  const { socket, socialSearchProgress, setSocialSearchProgress, clearSocialSearchProgress } = useWebSocketStore();

  useEffect(() => {
    if (!socket) {
      return;
    }

    // Listen for progress updates
    const handleProgressUpdate = (data: SocialSearchProgress) => {
      if (data.userId === userId) {
        setSocialSearchProgress(data);
        // Clear progress when completed or on error
        if (data.stage === 'COMPLETED' || data.stage === 'ERROR') {
          setTimeout(() => {
            clearSocialSearchProgress(userId);
          }, 2000); // Clear after 2 seconds
        }
      }
    };

    socket.on('social_search_progress', handleProgressUpdate);

    return () => {
      socket.off('social_search_progress', handleProgressUpdate);
      clearSocialSearchProgress(userId);
    };
  }, [socket, userId, setSocialSearchProgress, clearSocialSearchProgress]);

  return socialSearchProgress[userId] || null;
} 